export default "__VITE_ASSET__CFqFprCE__"